export function shippingLocationQuery(location?: {
  country?: string;
  state?: string;
  fulfilmentMethod?: string;
}): string {
  const qs = new URLSearchParams();
  if (location?.country) qs.set("country", location.country);
  if (location?.state) qs.set("state", location.state);
  if (location?.fulfilmentMethod) qs.set("fulfilmentMethod", location.fulfilmentMethod);
  const query = qs.toString();
  return query ? `?${query}` : "";
}
